import { IMytaverseFile } from '@interfaces/file';
export interface IMapFloor {
  id: string;
  name: string;
  image: IMytaverseFile;
}

export interface ITeleportLocation {
  id: string;
}

export interface ITeleportLocationPosition {
  x: number;
  y: number;
  z: number;
}

export interface ITeleportLocationRotation {
  yaw?: number;
  pitch?: number;
  roll?: number;
}

export interface ITeleportPreview {
  teleportId: string;
  previewImage: IMytaverseFile | null;
  id?: string;
  teleportLocation?: ITeleportLocation;
  name?: string;
  description?: string | null;
  screenshotName?: string;
  positionInWidget?: number;
  showInUi?: boolean;
  position?: ITeleportLocationPosition;
  rotation?: ITeleportLocationRotation;
}

export type TrainingTaskType = 'procedural' | 'evaluative';

export interface ITrainingTask {
  taskId: string;
  name: string;
  expectedDurationSec: number;
  // When absent, the task is treated as 'procedural' (see trainingAnalytics).
  type?: TrainingTaskType;
}

export interface ITrainingModule {
  moduleId: string;
  name: string;
  tasks: ITrainingTask[];
}

export interface IMapLayoutElementGeometry {
  kind: 'level' | 'class' | 'greybox';
  asset?: string;
  package?: string;
  available: boolean;
  cooked?: boolean;
}

export interface IMapLayoutElement {
  id: string;
  displayName: string;
  category: string;
  thumbnailUrl?: string;
  type?: string;
  size?: string;
  geometryLevel?: string;
  geometryClass?: string;
  overrideExit?: boolean;
  exitOffset?: number[];
  exitYawDeg?: number;
  geometry?: IMapLayoutElementGeometry;
}

export interface IMapLayoutCatalog {
  version: number;
  elements: IMapLayoutElement[];
}

export interface IMapLayout {
  version: number;
  rooms: string[];
}

export const MAP_LAYOUT_VERSION = 1;

export interface IMapRegion {
  name: string;
  type?: string;
  spots?: string[];
  // Marks the region UE designates as the map's entry point. When present,
  // this real region is used as the "on join" AI trigger instead of the
  // synthetic 'landing' pseudo-trigger.
  isStartingPoint?: boolean;
}

export interface IMap {
  mapId: string;
  ueIdentifier: string;
  name: string;

  displayName: string;
  mapName: string;
  imageBaseMap: string;
  id: string;
  thumbnail: string;

  floorPlans?: IMapFloor[];
  teleportPreviews?: ITeleportPreview[];
  trainingModules?: ITrainingModule[];
  regions?: IMapRegion[];
  layoutCatalog?: IMapLayoutCatalog;
}
